/**
 * Constructs a pagination URL by updating the page query parameter while preserving other query parameters
 * @param baseUrl - Base URL (pathname + search, e.g., "/path?filter=value")
 * @param pageNumber - The page number to navigate to
 * @returns Complete URL with updated page parameter
 */
export function getPaginationUrl(baseUrl: string, pageNumber: number): string {
  const urlParts = baseUrl.split('?')
  const pathname = urlParts[0]
  const queryString = urlParts[1] || ''

  const parameters = new URLSearchParams(queryString)
  if (pageNumber > 1) {
    parameters.set('page', pageNumber.toString())
  } else {
    parameters.delete('page')
  }

  const newQuery = parameters.toString()
  return newQuery ? `${pathname}?${newQuery}` : pathname
}
